import React from 'react'
import styled from 'styled-components'

import { FONTS } from '../../../../../constants'

export const SummaryRow = (props) => {
  const { totalCost, totalPrice, totalMargin } = props

  return (
    <Root>
      <TotalCost>
        <span>{`Total Cost: ฿ ${totalCost}`}</span>
      </TotalCost>
      <TotalPrice>
        <span>{`Total Price: ฿ ${totalPrice}`}</span>
      </TotalPrice>
      <Margin>
        <span>{`Margin (%): ${totalMargin}`}</span>
      </Margin>
    </Root>
  )
}

const Root = styled.div`
    width: 100%;
    height: 42px;
    display: flex;
    align-items: center;
    background: #404040;
    padding: 0 36px;
`

const TotalCost = styled.div`
    min-width: 250px;
    display: flex;
    align-items: center;

    span {
        font-family: ${FONTS.GOTHAM_MEDIUM};
        font-size: ${FONTS.SMALL_SIZE};
        color: #FFFFFF;
    }
`

const TotalPrice = styled(TotalCost)`
`

const Margin = styled(TotalCost)`
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-cost-planning/tab-pane-other-service/summary-row.js